<template>
  <ValidationProvider v-slot="{ errors }" :name="label" :rules="rules">
    <b-field
      :label="label"
      :type="{ 'is-danger': errors.length > 0 }"
      :message="errors[0]"
    >
      <b-input
        v-model="item"
        v-bind="$attrs"
        v-on="$listeners"
        @input="$emit('input', item)"
      />
    </b-field>
  </ValidationProvider>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: null,
    },
    rules: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number],
    },
  },
  data() {
    return {
      item: this.value,
    }
  },
  watch: {
    value() {
      this.item = this.value
    },
  },
}
</script>
